<template>
    <div class="business">
     <toast-message
        :message="errmsg"
        type="error"
        :isToastEnable="toast"
        @close="(val) => toast = val"
    />

    <div>
      

        <div>
          <div class="mask">
            <div class="img-user">
              <img src="@/assets/user.svg" class="oval" />
            </div>          
            <div class="month">
              <div class="employee-fullname">{{` ${releaseData.name} `}} </div>
              <div class="employee-code"> {{ `${releaseData.code}`}} </div>
              <div class="employee-code"> {{ `${releaseData.email_id == nulll ? "-" : releaseData.email_id}`}} </div>
              <div class="salary-perks">Current Status: <strong>{{ `${releaseData.current_status}`}}</strong></div>
            </div>
          </div>
      </div>


     <div class="input-label">Effective Date</div>
      <date-picker
        class="customwidth margin-b-15px"
        v-model="sendData.effective_from"
        :formatDate="'yyyy/MMM/dd'"
         @datevalue="(val)=> {sendData.effective_from=val; getDAteValue(val)}"
          :value="sendData.effective_from"
      />

    <pop-up-message
        v-if="showSuccessMsg"
        :message="`Salary of 1 Employee is Successfully Released.`"
        btnText="OK"
        @back="ok"
      ></pop-up-message>

      <footer>
        <popup-bottom-container>
          <template slot="end">
            <btn-grp class="form-button">
              <btn text="Back" type="secondary" @click="closePopup()"/>
              <btn text="Save" type="primary" @click ="savePlan()"/>
            </btn-grp>
          </template>
        </popup-bottom-container>
      </footer>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  name: "releaseSalaryPopup",
  props: {
    releaseSalaryEmployee:{
      type:Array
    }
  },
  data() {
    return {
      errmsg: "",
      toast: false,
      showSuccessMsg: false,
      releaseData:[],
      sendData:{
        employee_id:"",
        status:"Release",
        effective_from:"",
        reason:"",
        it_projection:false,
      }
    };
  },
  computed: {},

  mounted() {
    this.showSuccessMsg = false;
    this.fetchRecord();
  },

  activated() {
    this.toast = false;
    this.errmsg = "";
    this.showSuccessMsg = false;
  },

  methods: {
    ...mapActions({
    update_employee_status: "dashboard/payroll/utilities/holdsalary/updateEmployeeStatus",
    }),
      closePopup() {
          this.$emit('hidepopup');
      },
      fetchRecord(){
        let record = this.releaseSalaryEmployee;
        this.releaseData = record;
        //console.log("hold emp id is comminggggg",this.releaseData);
      },

      updateDateValues(value, dateObj) {
      try {
        this.sendData.effective_from = value;
       // this.employeeObject.last_working_date = "";
        this.sendData.effective_from = dateObj;
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
      }
    },

        async savePlan() {
         
         this.sendData.employee_id=this.releaseData.employee_id;
         
          let res = await this.update_employee_status(this.sendData);
         
          if(res.status==200){
            this.showSuccessMsg = true;    
          }else{
            //console.log("Something is missing");    
          }
        //this.showSuccessMsg = true;
        ////console.log("Stop data");
        //alert("Heloo");
      },
      // savePlan() {
      //   this.showSuccessMsg = true;
      //   //console.log("Stop data");
      // },
      ok() {
        this.showSuccessMsg = false;
        this.$router.push({
          path: `/dashboard/${this.$route.params.entity_index}/payroll/utilities/hold_release_salary`,
        });
        this.$emit('hidepopup');
        window.location.reload();
      },
  }    
}
</script>

<style lang="scss" scoped>
@import "@/scss/components/margins.scss"; //margins
@import "@/scss/_variables.scss";

.lineheight{
  height: 1px;
}

.mask {
  // width: 258.5px;
  max-width:300px;
  height: 144px;
  border-radius: 8px;
  border: solid 1px #e9e9e9;
  background-color: #ffffff;
  padding: 20px 24px;
  margin: 20px 20px 20px 0px;
}

.img-user {
    margin-right: 10px;
    position: absolute;
}

.oval {
  // background-color: #ffa000;
  width: 55px;
  height: 55px;
  border-radius: 41px;
}

.month {
    position: relative;
    margin-left: 32%;
}

.employee-fullname {
  text-transform: capitalize;
  font-family: Montserrat;
  font-size: 16px;
  font-weight: 500;
  color: #444444;
}

.employee-code {
  font-size: 13px;
  font-weight: normal;
  color: #979797;
}

.salary-perks {
  margin-top: 30px;
  font-size: 14px;
  font-weight: normal;
  color: #444444;
}
</style>